
import './Toptopic.scss';

const Toptopic = () => {

  const TopicItem = [
    {
      date: "1/11",
      topic: "DJ MEEK氏の新曲「TRACK AND FIELD」に参加",
      url: "https://linkco.re/7Tpz0hNg?lang=ja",
    },
    {
      date: "12/25",
      topic: "Single「問題ない」 Free Download配信中！",
      url: "https://www.dropbox.com/s/yf553qx444h4gak/%E5%95%8F%E9%A1%8C%E3%81%AA%E3%81%84.wav?dl=0",
    },
  ]
  return (
    <div className="Toptopic-container-main">
 <div className="Toptopic">
  <h3 className="Toptopic-title">NEWS</h3>
 <ul>
                {TopicItem.map((TopicItem) => (
                  <li>
                      
                      <p id="topicD">{TopicItem.date}</p>
                      <p id="topicT"><a href={TopicItem.url}>{TopicItem.topic}</a></p>
                  </li>
                ))}
              </ul>
 </div>

    </div>
  );
};

export default Toptopic;
